import { SvgIcon, SvgIconProps } from '@mui/material';

const HomeSideBar = ({ viewBox = '0 0 20 19', ...props }: SvgIconProps) => (
  <SvgIcon
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    sx={{ width: 20, height: 19, fill: 'none', ...props.sx }}
    data-testid="HomeSideBarIcon"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.164134 9.33285C0.299225 9.46443 0.488352 9.54338 0.65046 9.54338C0.812569 9.54338 0.947661 9.49075 1.08275 9.38549L1.86628 8.72759V17.5434C1.86628 17.9381 2.19049 18.2539 2.59576 18.2539H17.4287C17.834 18.2539 18.1582 17.9381 18.1582 17.5434V8.72759L18.9147 9.38549C19.1849 9.62233 19.6172 9.59601 19.8333 9.33285C20.0765 9.0697 20.0495 8.64864 19.7793 8.43812L10.431 0.411801C10.1879 0.201275 9.8096 0.201275 9.56644 0.411801L5.43267 3.93812L3.05507 6.01706L0.24519 8.43812C-0.0520089 8.67496 -0.0790287 9.0697 0.164134 9.33285ZM4.51405 13.8329V9.83285C4.51405 9.72759 4.59511 9.64864 4.70318 9.64864H8.918C9.02607 9.64864 9.10713 9.72759 9.10713 9.83285V13.8592C9.10713 13.9644 9.02607 14.0434 8.918 14.0434H4.70318C4.59511 14.0171 4.51405 13.9381 4.51405 13.8329ZM12.0251 9.64864H15.2673C15.3753 9.64864 15.4564 9.72759 15.4564 9.83285V16.8855C15.4564 16.9907 15.3753 17.0697 15.2673 17.0697H12.0251C11.917 17.0697 11.836 16.9907 11.836 16.8855V9.83285C11.836 9.72759 11.917 9.64864 12.0251 9.64864Z"
      fill="#0B1421"
    />
  </SvgIcon>
);

export default HomeSideBar;
